import { render } from "./Loading.vue?vue&type=template&id=48da32b7"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"
script.render = render

export default script